/* This file was automatically generated - please modify the template not this file! */

import axios from "axios";

import { AdminUserListModel, AdminUserDetailModel, AdminUserCreateModel, AdminUserEditModel } from "./model";

class AdminUserApi {

    private readonly apiUrl = "/api/adminuser";

    public async getAll(finished?: boolean): Promise<AdminUserListModel[]> {
        const params = window.location.href.substring(window.location.href.indexOf("?") + 1, window.location.href.length);
        const query = finished === true ? "?finished=true" + "&" + params : "?" + params;
        const response = await axios.get(`${this.apiUrl}${query}`);
        const data = response.data as AdminUserListModel[];
        return data.map(this.parseModel);
    }

    public async getAdminUsersWithClinicianRole(): Promise<AdminUserDetailModel[]> {
        const response = await axios.get(`${this.apiUrl}/getAdminUsersWithClinicianRole`);
        const data = response.data as AdminUserDetailModel[];
        return data.map(this.parseModel);
    }

    public async detail(id: any): Promise<AdminUserDetailModel> {
        const response = await axios.get(`${this.apiUrl}/${id}`);
        const model = response.data as AdminUserDetailModel;
        return this.parseModel(model);
    }

    public async save(adminUser: AdminUserEditModel): Promise<AdminUserDetailModel> {
        const response = await axios.put(`${this.apiUrl}/${adminUser.id}`, adminUser);
        const model = response.data as AdminUserDetailModel;
        return this.parseModel(model);
    }

    public async create(adminUser: AdminUserCreateModel): Promise<AdminUserDetailModel> {

        const response = await axios.post(this.apiUrl, adminUser);
        const model = response.data as AdminUserDetailModel;
        return this.parseModel(model);
    }

    public delete(id: any): Promise<void> {
        return axios.delete(`${this.apiUrl}/${id}`);
    }

    public parseModel(model: AdminUserDetailModel): AdminUserDetailModel {
        return {
            ...model
        };
    }
}

export default new AdminUserApi();
